import { useForm, Controller} from "react-hook-form";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";

import {alert, confirm} from "../components/MegConfirmAlert";

import Loading from "../components/Loading";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import Sheet from 'react-modal-sheet';
import { useState, useEffect } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import { useParams } from "react-router";

export default function TestPage(){

    const [isOpen, setOpen] = useState(false);
    const parmas = useParams()
    console.log(parmas)
    const {register, handleSubmit, control, formState }= useForm();
    const{errors} = formState;  

    useEffect(() => {
        fetch('/api/getData')
            .then(response => response.json())
            .then(data => console.log(data));
    }, []);

    const onSubmit = data=>{    	
        console.log(data)
        
        
    }

    //아래의 내용은 나중에 jsx 페이지로 생성
    const popover = (
        <Popover id="popover-basic">
          <Popover.Header as="h3">Popover right</Popover.Header>
          <Popover.Body>
            And here's some <strong>amazing</strong> content. It's very engaging.
            right?
          </Popover.Body>
        </Popover>
    );


    const ConfirmTest = async () => {
       
        const result = await confirm('메세지', {okText : '진짜로?' , cancelText :'취소'});
        if(result){
            alert('OK click');    
        }
            
        
    }

    const AlertTest = () => {
        alert('메세지 출력 \n 줄바꿈');  // 느낌표
        alert('메세지 출력 \n 줄바꿈', {okButtonStyle : 'secondary'});  // Check
    }

    return(

        <div className="container">
            <h1>Form</h1>

            <form onSubmit={handleSubmit(onSubmit)}>
                <label>React Select</label> 
                <input {...register("userId", { required:"필수 응답 항목입니다."})}/>
                {errors.userId && <p role="alert">{errors.userId.message}</p>}
                <input type="password" {...register("password", { required:"필수 응답 항목입니다.", minLength:{ value:8, message:"비밀번호는 8자 이상이여야 합니다," }})} />
                {errors.password && <p role="alert">{errors.password.message}</p>}

                <Controller
                    name={"searchDate"}                  
                    control={control}                  
                    rules={{  required:"필수 응답 항목입니다."  }}
                    render={({ field: { onChange, value } }) => {
                        return (
                        <DatePicker
                            locale={ko}
                            onChange={onChange}
                            selected={value}
                            placeholderText="날짜를 입력해주세요."
                        />
                        );
                    }}
                    />
                    {errors.searchDate && <p role="alert">{errors.searchDate.message}</p>}
                <button  type="submit">전송</button>  
            </form>
            <button  type="button" onClick={ConfirmTest}>Confirm</button><br></br>
            <button  type="button" onClick={AlertTest}>alert</button><br></br>    


            <button  type="button" onClick={() => setOpen(true)}>Open sheet</button><br></br>    
            
            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                <button  type="button" >popover</button>    
            </OverlayTrigger>

            <br></br>

            <Tabs
                id="controlled-tab-example"
                defaultActiveKey="home"
                className="mb-3"
                >
                <Tab eventKey="home" title="Home">
                    Tab content for Home
                </Tab>
                <Tab eventKey="profile" title="Profile">
                    Tab content for Profile
                </Tab>
                <Tab eventKey="contact" title="Contact" >
                    Tab content for Contact
                </Tab>
            </Tabs>            



            <Sheet isOpen={isOpen} onClose={() => setOpen(false)}>
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>내용내용내용내용</Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onClick={() => setOpen(false)} />
            </Sheet>

            <Loading />
        </div>
    );
};